export const SET_USER = "SET_USER"
export const LOGOUT_USER = "LOGOUT_USER"
export const SET_USER_RESPONSE = "SET_USER_RESPONSE"
export const TOGGLE_USER_RESPONSE = "TOGGLE_USER_RESPONSE"
export const SET_PRODUCTS = "SET_PRODUCTS"
export const SET_CART = "SET_CART"
export const SET_ORDERS = "SET_ORDERS"
export const TOGGLE_ISPRODUCTFETCHING_STATE = "TOGGLE_ISPRODUCTFETCHING_STATE"
export const TOGGLE_IS_CART_FETCHING = "TOGGLE_IS_CART_FETCHING"
export const TOGGLE_IS_ORDER_FETCHING = "TOGGLE_IS_ORDER_FETCHING"
